import { BitrixVue } from 'ui.vue3';
import { VueReCaptcha} from 'vue-recaptcha-v3';
import SubscriptionForm from './components/SubscriptionForm.vue';

BX(() => {

    const element = document.querySelector('#subscription');
    if (!element) {
        return;
    }

    const captchaPublicKey = element.dataset.captchaPublicKey;

    const subscription = BitrixVue.createApp({ components: { SubscriptionForm }, template: '<SubscriptionForm/>' });
    subscription.use(VueReCaptcha, { siteKey: captchaPublicKey });
    subscription.mount(element);

});
